module.exports = __webpack_public_path__ + "stylesheets/about_afc539d98a694e1ba8279a09964ccc56.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/about.less
// module id = imWQ
// module chunks = 118